













































































































































































































































import { Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { newVirtualMachineService } from '@/components/new-virtual-machine/services/NewVirtualMachineService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import EventBus from '@/EventBus';

@Component({
  props: ['configuration', 'accessAgreement'],
  components: {
    PriceWithCurrency,
  },
})
export default class NewVirtualMachineSummary extends Vue {
  clusterResources: any = null;
  config: any = null;
  priceModifier = 0.00001;
  hoursInMonth = 730;
  workspaceId = 0;
  regionId = 0;
  isLimitExceeded = false;
  limitReached: any = {
    cpu_cores: false,
    ram: false,
    storage: false,
    public_networks: false,
  };
  isLoading = false;
  boxTop = 0;
  isFirstVM: boolean = false;
  virtualMachines: any = [];

  @Watch('$store.state.virtualMachines.virtualMachines', { immediate: true, deep: true })
  onMachinesChange() {
    this.virtualMachines = this.$store.getters['virtualMachines/getMachines'];
  }

  @Watch('configuration', { immediate: true, deep: true })
  onConfigurationUpdated(conf: any) {
    if (conf && conf.params && conf.params.profile) {
      this.config = conf;
      this.clusterResources = conf.params.profile.resources;
    }
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    window.addEventListener('scroll', () => {
      if (window.scrollY > 145) {
        this.boxTop = window.scrollY - 145;
      } else {
        this.boxTop = 0;
      }
    });
  }
  @Emit()
  onMachineNameError() {
    return;
  }
  @Emit()
  onNetworkError() {
    return;
  }
  @Emit()
  onWinAgreementError() {
    return;
  }
  closeModal() {
    this.isLimitExceeded = false;
  }
  create() {
    let isError = false;
    if (!this.$props.configuration.name) {
      this.onMachineNameError();
      window.scrollTo(0, document.body.scrollHeight);
      isError = true;
    }
    if (!this.$props.configuration.network) {
      this.onNetworkError();
      window.scrollTo(0, document.body.scrollHeight);
      isError = true;
    }
    if (
      !this.$props.accessAgreement &&
      this.$props.configuration.system &&
      this.$props.configuration.system.name.toLowerCase().indexOf('windows') !== -1
    ) {
      this.onWinAgreementError();
      isError = true;
    }
    if (isError) {
      return;
    }
    let auth = {
      type: 'ssh',
      ssh_keys: this.$props.configuration.keys,
    };

    if (this.$props.configuration.authType === 'pass') {
      auth = {
        type: 'password',
        ssh_keys: [],
      };
    }
    const machineData: any = {
      name: this.$props.configuration.name,
      operating_system_version_id: this.$props.configuration.version.id,
      cluster_id: this.$props.configuration.params.profile.id,
      cpu_cores: this.$props.configuration.params.cpu,
      ram: this.$props.configuration.params.ram,
      primary_disk: {
        size: this.$props.configuration.params.primaryDisk,
        type: this.$props.configuration.params.primaryDiskType.toLowerCase(),
      },
      additional_disks: [],
      authorization: auth,
      private_network_id: this.$props.configuration.network.id,
      add_dedicated_public_ip: this.$props.configuration.ip,
    };

    for (let additionalDisk of this.$props.configuration.params.additionalDisks) {
      machineData.additional_disks.push({
        size: additionalDisk.value,
        type: additionalDisk.diskType.toLowerCase(),
      });
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    newVirtualMachineService
      .createVirtualMachine(this.workspaceId, this.regionId, machineData)
      .then(() => {
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
        if (this.virtualMachines.length === 0) {
          this.isFirstVM = true;
        } else {
          this.$router.push(`/workspaces/${this.workspaceId}/regions/${this.regionId}`).catch(() => {});
        }
        EventBus.$emit('show-info', this.$t('ws.vm.create.started'));
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data && data.data && data.status === 422) {
          let error = data.data.error || {};
          if (error.cpu_cores && error.cpu_cores[0] && error.cpu_cores[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.cpu_cores = true;
          }
          if (error.ram && error.ram[0] && error.ram[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.ram = true;
          }
          if (error.storage && error.storage[0] && error.storage[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.storage = true;
          }
          if (error.public_networks && error.public_networks[0] && error.public_networks[0].error === 'limit_reached') {
            this.isLimitExceeded = true;
            this.limitReached.public_networks = true;
          }
        }
      });
  }

  cpuPrice(multiplier: number = 1) {
    if (!this.clusterResources) {
      return 0;
    }
    return this.clusterResources.cpu.price.cents * this.priceModifier * this.config.params.cpu * multiplier;
  }

  ramPrice(multiplier: number = 1) {
    if (!this.clusterResources || !this.clusterResources.ram) {
      return 0;
    }
    return this.clusterResources.ram.price.cents * this.priceModifier * this.config.params.ram * multiplier;
  }

  ipPrice(multiplier: number = 1) {
    if (!this.config || !this.config.ip) {
      return 0;
    }
    return this.config.ipPrice.cents * this.priceModifier * multiplier;
  }

  primaryDiscPrice(multiplier: number = 1) {
    if (!this.clusterResources) {
      return 0;
    }
    if (this.$props.configuration.params.primaryDiskType === 'HDD') {
      return (
        this.clusterResources.primary_disk.price.hdd.cents *
        this.priceModifier *
        this.config.params.primaryDisk *
        multiplier
      );
    } else {
      return (
        this.clusterResources.primary_disk.price.ssd.cents *
        this.priceModifier *
        this.config.params.primaryDisk *
        multiplier
      );
    }
  }

  additionalDiscPrice(index: number, price: number, multiplier: number = 1) {
    if (!this.clusterResources) {
      return 0;
    }
    if (
      this.$props.configuration.params.additionalDisks[index] &&
      this.$props.configuration.params.additionalDisks[index].diskType === 'HDD'
    ) {
      return this.clusterResources.additional_disk.price.hdd.cents * this.priceModifier * price * multiplier;
    } else {
      return this.clusterResources.additional_disk.price.ssd.cents * this.priceModifier * price * multiplier;
    }
  }

  systemPrice(multiplier: number = 1) {
    if (
      !this.config ||
      !this.config.params ||
      !this.config.params.profile ||
      !this.config.params.profile.licences_price
    ) {
      return 0;
    }
    return this.config.params.profile.licences_price.cents * this.priceModifier * multiplier;
  }

  totalPrice(multiplier: number = 1) {
    let additionalDisksPrice = 0;
    if (this.config && this.config.params && this.config.params.additionalDisks.length > 0) {
      additionalDisksPrice = this.config.params.additionalDisks.reduce((value: number, item: any, index: any) => {
        return this.additionalDiscPrice(index, item.value, multiplier) + value;
      }, 0);
    }
    return (
      this.systemPrice(multiplier) +
      this.cpuPrice(multiplier) +
      this.ramPrice(multiplier) +
      this.primaryDiscPrice(multiplier) +
      additionalDisksPrice +
      this.ipPrice(multiplier)
    );
  }
}
